
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IStepperProps,
  IStepperMapperProps,
  IStepperControllerProps,
  IStepperStateValues,
} from '../../../components/Stepper/Stepper.props';

export default withCompController<
  IStepperMapperProps,
  IStepperControllerProps,
  IStepperProps,
  IStepperStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
